import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ChevronRight } from "lucide-react";
import { easeExpo } from "@/components/common/motion";

/* Consistent hero header for inner pages */
export default function PageHeader({ overline, title, subtitle, crumb }) {
  return (
    <section className="relative overflow-hidden border-b border-border grain" data-testid="page-header">
      <div className="pointer-events-none absolute inset-0 -z-10">
        <div className="absolute -left-32 -top-20 h-96 w-96 rounded-full bg-primary/15 blur-[120px]" />
        <div className="absolute right-0 top-0 h-80 w-80 rounded-full bg-accent/10 blur-[120px]" />
      </div>
      <div className="mx-auto max-w-7xl px-5 pb-16 pt-16 sm:px-8 sm:pb-20 sm:pt-20">
        <nav className="mb-8 flex items-center gap-2 text-sm text-muted-foreground" aria-label="Breadcrumb">
          <Link to="/" className="hover:text-foreground">Home</Link>
          <ChevronRight className="h-3.5 w-3.5" />
          <span className="text-foreground">{crumb || title}</span>
        </nav>
        {overline && (
          <div className="mb-4 flex items-center gap-2">
            <span className="h-px w-8 bg-primary" />
            <span className="text-xs font-bold uppercase tracking-[0.22em] text-primary">{overline}</span>
          </div>
        )}
        <motion.h1
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: easeExpo }}
          className="max-w-4xl font-display text-4xl font-semibold tracking-tight leading-[1.05] sm:text-5xl lg:text-6xl text-balance"
        >
          {title}
        </motion.h1>
        {subtitle && (
          <motion.p
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.15 }}
            className="mt-6 max-w-2xl text-lg leading-relaxed text-muted-foreground"
          >
            {subtitle}
          </motion.p>
        )}
      </div>
    </section>
  );
}
